export const nav = {
  homeLabel: "Klap home",
  pricing: "Pricing",
  resources: "Resources",
  api: "API",
  blog: "Blog",
  discord: "Discord",
  affiliate: "Affiliate",
  logIn: "Log in",
  getStarted: "Get started",
  dashboard: "Dashboard",
};
